import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import SBoxTable from './sbox';
import { useState } from 'react';

const Page3 = (rond) => {
  const navigate = useNavigate();
  const location = useLocation();
  const allResults = location.state.allResults;
  const userInput = location.state.userInput;
  const userKey = location.state.userKey;
  let hexInput = userKey;
  const allEncResults = location.state.allEncResults;
  console.log("allEncResults", allEncResults);
  let { round } = rond;
  round = round -1;
  round = round / 4;


  const firstpage = () => {
    navigate("/page2", {
      state: { allResults, allEncResults, userInput, hexInput },
    });
  };

  const secondpage = () => {
    navigate("/page4" , { state: { allResults, allEncResults, userInput, userKey, cols } });
  };

  const icon = {
    hidden: {
      x: -700,
    },
    visible: {
      x: 0,
      transition: {
        delay: 0.25,
        duration: 1,
      },
    },
  };

  let data0 = allEncResults[0][round].toString().split(" ");

  let cols = [
    [data0.slice(0, 4)],
    [data0.slice(4, 8)],
    [data0.slice(8, 12)],
    [data0.slice(12, 16)],
  ];

  console.log(cols);
  let data = allEncResults[1][round].toString().split(" ");
  console.log("data", data);

  let cols2 = [
    [data.slice(0, 4)],
    [data.slice(4, 8)],
    [data.slice(8, 12)],
    [data.slice(12, 16)],
  ];


  const renderTable = () => {
    const table = [];

    for (let i = 0; i < 4; i++) {
      const row = [];
      for (let j = 0; j < 4; j++) {
        row.push(
          <td key={j} className="px-6 py-4 whitespace-nowrap">
            <div className="text-sm text-gray-900">{cols[j][0][i]}</div>
          </td>
        );
      }
      table.push(<tr key={i}>{row}</tr>);
    }

    return table;
  };

  const renderTable2 = () => {
    const table = [];

    for (let i = 0; i < 4; i++) {
      const row = [];
      for (let j = 0; j < 4; j++) {
        row.push(
          <td key={j} className="px-6 py-4 whitespace-nowrap">
            <div className="text-sm text-gray-900">{cols2[j][0][i]}</div>
          </td>
        );
      }
      table.push(<tr key={i}>{row}</tr>);
    }

    return table;
  };

  const sBoxData = [
    ['63', '7C', '77', '7B', 'F2', '6B', '6F', 'C5', '30', '01', '67', '2B', 'FE', 'D7', 'AB', '76'],
    ['CA', '82', 'C9', '7D', 'FA', '59', '47', 'F0', 'AD', 'D4', 'A2', 'AF', '9C', 'A4', '72', 'C0'],
    ['B7', 'FD', '93', '26', '36', '3F', 'F7', 'CC', '34', 'A5', 'E5', 'F1', '71', 'D8', '31', '15'],
    ['04', 'C7', '23', 'C3', '18', '96', '05', '9A', '07', '12', '80', 'E2', 'EB', '27', 'B2', '75'],
    ['09', '83', '2C', '1A', '1B', '6E', '5A', 'A0', '52', '3B', 'D6', 'B3', '29', 'E3', '2F', '84'],
    ['53', 'D1', '00', 'ED', '20', 'FC', 'B1', '5B', '6A', 'CB', 'BE', '39', '4A', '4C', '58', 'CF'],
    ['D0', 'EF', 'AA', 'FB', '43', '4D', '33', '85', '45', 'F9', '02', '7F', '50', '3C', '9F', 'A8'],
    ['51', 'A3', '40', '8F', '92', '9D', '38', 'F5', 'BC', 'B6', 'DA', '21', '10', 'FF', 'F3', 'D2'],
    ['CD', '0C', '13', 'EC', '5F', '97', '44', '17', 'C4', 'A7', '7E', '3D', '64', '5D', '19', '73'],
    ['60', '81', '4F', 'DC', '22', '2A', '90', '88', '46', 'EE', 'B8', '14', 'DE', '5E', '0B', 'DB'],
    ['E0', '32', '3A', '0A', '49', '06', '24', '5C', 'C2', 'D3', 'AC', '62', '91', '95', 'E4', '79'],
    ['E7', 'C8', '37', '6D', '8D', 'D5', '4E', 'A9', '6C', '56', 'F4', 'EA', '65', '7A', 'AE', '08'],
    ['BA', '78', '25', '2E', '1C', 'A6', 'B4', 'C6', 'E8', 'DD', '74', '1F', '4B', 'BD', '8B', '8A'],
    ['70', '3E', 'B5', '66', '48', '03', 'F6', '0E', '61', '35', '57', 'B9', '86', 'C1', '1D', '9E'],
    ['E1', 'F8', '98', '11', '69', 'D9', '8E', '94', '9B', '1E', '87', 'E9', 'CE', '55', '28', 'DF'],
    ['8C', 'A1', '89', '0D', 'BF', 'E6', '42', '68', '41', '99', '2D', '0F', 'B0', '54', 'BB', '16'],
  ];

  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  return (
    <>
    {isVisible && (
        <div className="fixed top-16 right-8 h-3/5 w-1/5 rounded-xl bg-emerald-100 shadow p-4">
          <div className="text-center">
            <h2 className="text-xl pb-10 pt-4 font-semibold">
              How S-box Substitution is performed
            </h2>
            <p className="text-sm">
              every element in initial transformation matrix has 2 parts
              <br />
              <br />
              the first part represents the row and the
              <br />
              <br />
              the second part represents the column
              <br />
              <br />
              look up the respective element in s-box and fill the After S-box substition matrix
            </p>
          </div>
        </div>
      )}
      
      <div className="input-container">
        <div className="flex flex-col items-center">
          <div>
            <h2 className=" font-semibold text-2xl">Round {round+1}</h2>
            <h2 className=" font-semibold text-xl">Step 1</h2>
            <h2 className=" font-semibold text-xl">S-Box Substitution</h2>
            

            <div className="grid grid-flow-col grid-cols-5 gap-2 align-middle pt-28">
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 2 }}
                className="w-fit pl-5"
              >
                <table className=" bg-emerald-100 rounded-xl w-auto">
                  <tbody className="">{renderTable()}</tbody>
                </table>
                <p className="align-middle"> Initial transformation</p>
              </motion.div>

              <div className=" pt-20 pl-7">
                <svg
                  width="170"
                  height="38"
                  viewBox="0 0 573 38"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <motion.path
                    variants={icon}
                    initial="hidden"
                    animate="visible"
                    d="M571.771 20.7678C572.748 19.7915 572.748 18.2085 571.771 17.2322L555.861 1.32233C554.885 0.34602 553.302 0.34602 552.326 1.32233C551.349 2.29864 551.349 3.88155 552.326 4.85786L566.468 19L552.326 33.1421C551.349 34.1184 551.349 35.7014 552.326 36.6777C553.302 37.654 554.885 37.654 555.861 36.6777L571.771 20.7678ZM0 21.5H570.003V16.5H0V21.5Z"
                    fill="black"
                  />
                </svg>
              </div>

              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 2 }}
                className="w-fit"
              >
                <table className=" bg-emerald-100 rounded-xl w-auto">
                  <tbody className="">{renderTable2()}</tbody>
                </table>
                <p className="align-middle"> After S-box substition</p>
              </motion.div>

              <motion.div
             initial={{ opacity: 0, scale: 0.8 }}
             animate={{ opacity: 1, scale: 1 }}
             transition={{ delay: 1.5 }}
             >
            <SBoxTable sBoxData={sBoxData} highlightedRow={cols[0][0][0][0]} highlightedColumn={cols[0][0][0][1]} />
            </motion.div>
            
            </div>
            <div className="bg-emerald-100 rounded-xl w-20 p-2 ml-60">
            <p
              style={{ cursor: 'pointer',}}
              onClick={toggleVisibility}
            >
              Explain
            </p>
            </div>
            
          </div>
        </div>
      </div>
      {/* <div class="button-holder">
        <div class="prev-button" onClick={firstpage}>
          PREVIOUS
        </div>
        <div className="next-button" onClick={secondpage}>
          NEXT
        </div>
      </div> */}
    </>
  );
};

export default Page3;
